export default {"src":"/_next/static/image/public/images/ic_add_family_member.e0327988f5b1700308cb2576f299548d.svg","height":130,"width":120};